import { useState } from "react";
import PageHero from "../components/PageHero";
import TerminalWindow from "../components/TerminalWindow";
import NeonCard from "../components/NeonCard";
import SectionHeading from "../components/SectionHeading";

const PUB = process.env.PUBLIC_URL || "";

const TRIVIA = [
  {
    q: "Did you know Mike was the one who wrote Simple?",
    a: "Yes. He did. And we will never recover.",
  },
  {
    q: "Did you know his mother painted those incredible abstract paintings the band used to hang on stage in the early 90's?",
    a: "Yes. Marjorie Minkin. Look her up. The legacy is loud.",
  },
  {
    q: "Did you know Mike has more pairs of pants than days in a calendar quarter?",
    a: "Allegedly. Source: our eyes.",
  },
];

export default function NewsletterPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  }

  return (
    <>
      <PageHero
        eyebrow="MGFC // dispatches"
        title="Newsletter"
        tagline="◢ We no are no nice guy ◣"
        image={`${PUB}/uploads/2018/08/116_phish_photo_rene_huemer.jpg`}
        accent="cyan"
      />

      {/* SIGNUP --------------------------------------------------------------- */}
      <section className="mx-auto max-w-3xl px-4 pt-20 sm:px-6 lg:px-8">
        <TerminalWindow
          title="signup.exe"
          status={submitted ? "STATUS // TRANSMITTED" : "STATUS // STANDING BY"}
          accent="cyan"
        >
          <div className="space-y-6 p-6 sm:p-10">
            <p className="font-mono text-sm uppercase tracking-[0.3em] text-mgfc-cyan">
              // OBJECTIVE
            </p>
            <p className="font-mono text-base leading-relaxed text-mgfc-fg/85 sm:text-lg">
              Sign up for our newsletter and{" "}
              <span className="text-mgfc-magenta">never miss out</span> on a new
              haircut or pair of pants again.
            </p>

            {submitted ? (
              <div className="border border-mgfc-lime/60 bg-mgfc-lime/5 p-6 font-mono text-mgfc-lime shadow-[0_0_24px_rgba(159,255,0,0.25)]">
                <p className="text-sm uppercase tracking-[0.35em]">
                  ▸ Transmission received
                </p>
                <p className="mt-3 text-mgfc-fg/85">
                  <span className="mr-2 text-mgfc-cyan">&gt;</span>
                  We have logged{" "}
                  <span className="text-mgfc-lime">{email}</span> into the
                  groovestream. Stay tuned for updates from the road, cosmic
                  whisperings, and the latest pant intel.
                </p>
                <p className="mt-2 font-mono text-xs uppercase tracking-[0.3em] text-mgfc-fg/45">
                  <span className="animate-blink-cursor">█</span> awaiting
                  bombtastic news
                </p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="flex flex-col gap-4 sm:flex-row sm:items-end"
              >
                <label className="flex-1">
                  <span className="block font-mono text-[11px] uppercase tracking-[0.4em] text-mgfc-magenta">
                    ▸ enter your email
                  </span>
                  <input
                    type="email"
                    required
                    autoComplete="email"
                    placeholder="your.email@phan.dom"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-2 w-full border-0 border-b-2 border-mgfc-magenta bg-black/40 px-3 py-3 font-mono text-lg text-mgfc-cyan placeholder:text-mgfc-magenta/40 focus:border-mgfc-cyan focus:shadow-[0_0_15px_#00FFFF] focus:outline-none"
                  />
                </label>
                <button
                  type="submit"
                  className="skew-btn skew-btn--magenta self-start sm:self-auto"
                >
                  <span>▸ Transmit</span>
                </button>
              </form>
            )}
            <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-mgfc-fg/40">
              // No spam. Just sploofs.
            </p>
          </div>
        </TerminalWindow>
      </section>

      {/* WHY ------------------------------------------------------------------ */}
      <section className="mx-auto max-w-5xl px-4 py-20 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="// what gets transmitted"
          title="Cosmic whisperings, smushed"
          accent="orange"
          align="left"
        />
        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <NeonCard topAccent="orange" sideAccent="magenta">
            <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-mgfc-orange">
              // PURPOSE
            </p>
            <p className="mt-4 font-mono text-base leading-relaxed text-mgfc-fg/85">
              The aim of our newsletter is to bring to light the wonderful and
              eccentric happenings of the world of Phish and Mike-related
              material. Whether it be a funky new pair of pants Mike is teasing
              us with on Instagram or a heartfelt message we have for you
              delighted fans, the newsletter is where all information is
              smushed into a small swimming pool to be{" "}
              <span className="text-mgfc-cyan">weighed</span>… and read. What do
              ya say?!
            </p>
          </NeonCard>
          <NeonCard topAccent="cyan" sideAccent="orange">
            <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-mgfc-cyan">
              // FORMAT
            </p>
            <p className="mt-4 font-mono text-base leading-relaxed text-mgfc-fg/85">
              Our newsletter is entirely curated by the people, for the people.
              Anything you'd like featured can be made possible by calling the
              hotline or sending an electronic hand-written letter to our fan
              email. We will have games to take part in, updates from the road,
              and much more. You may learn something you've never known before
              by reading the newsletter.
            </p>
          </NeonCard>
        </div>
      </section>

      {/* TRIVIA --------------------------------------------------------------- */}
      <section className="mx-auto max-w-5xl px-4 pb-24 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="// did you know??"
          title="Sample dispatch"
          accent="magenta"
          align="left"
        />
        <div className="mt-10 space-y-4">
          {TRIVIA.map((t, i) => (
            <div
              key={i}
              className="border-l-2 border-mgfc-magenta bg-mgfc-card/50 p-5 sm:p-6"
            >
              <p className="font-mono text-xs uppercase tracking-[0.35em] text-mgfc-magenta">
                Q{String(i + 1).padStart(2, "0")}
              </p>
              <p className="mt-2 font-display text-lg font-bold uppercase leading-tight tracking-tight text-mgfc-fg sm:text-xl">
                {t.q}
              </p>
              <p className="mt-3 font-mono text-mgfc-cyan">
                <span className="mr-2 opacity-60">A&gt;</span>
                {t.a}
              </p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
